import React from 'react';
import {
    CHAT_TEST_ID_PREFIX,
    OPENAI_CHATKIT_TEST_ID,
} from 'modules/taboola-common-frontend-modules/chat-agent/constants';
import { ChatBox } from '../ChatBox/ChatBox';
import { ChatContainer } from '../ChatContainer/ChatContainer';

export const ChatKitContainer = ({ chatKitContainerRef, isHidden, closeChat }) => {
    const testIdPrefix = CHAT_TEST_ID_PREFIX.CHATKIT;

    return (
        <ChatContainer closeChat={closeChat} isHidden={isHidden} testIdPrefix={testIdPrefix}>
            <ChatBox testIdPrefix={testIdPrefix}>
                <openai-chatkit id="chatkit" data-testid={OPENAI_CHATKIT_TEST_ID} ref={chatKitContainerRef} />
            </ChatBox>
        </ChatContainer>
    );
};
